var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",attrs:{"id":"video","width":_vm.width,"height":_vm.height,"src":_vm.src,"autoplay":_vm.autoplay},domProps:{"srcObject":_vm.stream}})}
var staticRenderFns = []

export { render, staticRenderFns }